export const ClaimNudgeImage = () => (
  <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M42.1396 72.3178L42.1397 72.3179L55.0032 59.4539L43.6869 48.1377L36.3411 55.4838L47.6572 66.7999L42.1396 72.3178Z"
      fill="#D2D7DF"
    />
    <path
      d="M68.5338 72.9845L61.1882 80.3301L72.5045 91.6463L79.85 84.3008L68.5338 72.9845Z"
      fill="#D2D7DF"
    />
    <path
      d="M61.1883 80.3303L48.3243 93.1934C46.5171 95.0007 44.1148 95.9958 41.5589 95.9958C39.0036 95.9958 36.6009 95.0007 34.7936 93.1938C31.0635 89.4633 31.0635 83.3937 34.7941 79.6631L42.1395 72.3175L47.6571 66.7996L36.341 55.4835L23.4774 68.3469C13.5076 78.3171 13.5076 94.5399 23.4769 104.51C28.3069 109.34 34.7287 112 41.5589 112C48.3896 112 54.811 109.34 59.641 104.51L66.9866 97.1645L72.5045 91.6466L61.1883 80.3303Z"
      fill="#EE399E"
    />
    <path
      d="M103.801 65.2845C103.417 65.2845 103.033 65.1376 102.74 64.8441L99.1045 61.2015C98.519 60.6151 98.52 59.6654 99.1064 59.0804C99.6924 58.4945 100.642 58.4955 101.228 59.0824L104.863 62.725C105.448 63.3114 105.447 64.2611 104.861 64.8461C104.568 65.1385 104.185 65.2845 103.801 65.2845Z"
      fill="#FDC221"
    />
    <path
      d="M67.8423 29.3246C67.459 29.3246 67.0752 29.1786 66.7827 28.8861L63.1406 25.2504C62.5542 24.6649 62.5532 23.7152 63.1387 23.1293C63.7231 22.5428 64.6734 22.5409 65.2598 23.1273L68.9019 26.7631C69.4883 27.3485 69.4893 28.2982 68.9038 28.8842C68.6108 29.1776 68.2266 29.3246 67.8423 29.3246Z"
      fill="#FDC221"
    />
    <path
      d="M100.166 29.3252C99.7822 29.3252 99.3984 29.1787 99.1055 28.8857C98.5195 28.3003 98.5195 27.3506 99.1055 26.7646L102.741 23.1289C103.326 22.543 104.276 22.543 104.862 23.1289C105.448 23.7144 105.448 24.6641 104.862 25.25L101.227 28.8857C100.934 29.1787 100.55 29.3252 100.166 29.3252Z"
      fill="#FDC221"
    />
    <path
      d="M64.2002 65.2842C63.8164 65.2842 63.4326 65.1377 63.1397 64.8447C62.5537 64.2593 62.5537 63.3096 63.1397 62.7236L66.7817 59.0811C67.3667 58.4951 68.3169 58.4951 68.9028 59.0811C69.4888 59.6665 69.4888 60.6162 68.9028 61.2021L65.2607 64.8447C64.9683 65.1377 64.584 65.2842 64.2002 65.2842Z"
      fill="#FDC221"
    />
    <path
      d="M112.002 45.5059H106.858C106.03 45.5059 105.358 44.8345 105.358 44.0059C105.358 43.1772 106.03 42.5059 106.858 42.5059H112.002C112.831 42.5059 113.502 43.1772 113.502 44.0059C113.502 44.8345 112.831 45.5059 112.002 45.5059Z"
      fill="#FDC221"
    />
    <path
      d="M61.1436 45.5059H56C55.1714 45.5059 54.5 44.8345 54.5 44.0059C54.5 43.1772 55.1714 42.5059 56 42.5059H61.1436C61.9722 42.5059 62.6436 43.1772 62.6436 44.0059C62.6436 44.8345 61.9722 45.5059 61.1436 45.5059Z"
      fill="#FDC221"
    />
    <path
      d="M84.001 22.6436C83.1724 22.6436 82.501 21.9722 82.501 21.1436V16C82.501 15.1714 83.1724 14.5 84.001 14.5C84.8296 14.5 85.501 15.1714 85.501 16V21.1436C85.501 21.9722 84.8296 22.6436 84.001 22.6436Z"
      fill="#FDC221"
    />
    <path
      d="M84.001 73.5C83.1724 73.5 82.501 72.8286 82.501 72V66.8564C82.501 66.0278 83.1724 65.3564 84.001 65.3564C84.8296 65.3564 85.501 66.0278 85.501 66.8564V72C85.501 72.8286 84.8296 73.5 84.001 73.5Z"
      fill="#FDC221"
    />
    <path
      d="M99.4577 48.5131L94.4173 41.7602L97.122 33.7822C97.7323 31.9848 96.0156 30.2679 94.2182 30.8783L94.2224 30.8825L86.2443 33.5872L79.4914 28.5469C77.9695 27.4149 75.8076 28.5172 75.8287 30.412L75.9347 38.8352L69.0546 43.6975C67.5031 44.7913 67.8847 47.1906 69.6947 47.7544L77.7405 50.2555L80.2417 58.3014C80.8055 60.1114 83.2049 60.4929 84.2986 58.9414L89.1609 52.0614L97.5926 52.1758C98.3015 52.1853 98.8984 51.8892 99.3103 51.436L99.319 51.4273C100.004 50.6658 100.167 49.4657 99.4577 48.5131Z"
      fill="#FDC221"
    />
  </svg>
);
